export default "__VITE_ASSET__CTM$sbMV__"